import { Boolean, Number, Optional, Record, Static, String } from 'runtypes';

export const UserRunType = Record({
	avatar: String,
	firstName: String,
	id: Number,
	initial: String,
	lastName: String,
	userName: String,
});

export type User = Static<typeof UserRunType>;

export const UserConfigurationAndEffectiveRightsRunType = Record({
	addOns: Boolean,
	administration: Optional(Boolean),
	agendaList: Boolean,
	agentManageGlobalMemory: Boolean,
	agentManageInstanceMemory: Boolean,
	agentManageInstanceProviders: Boolean,
	agentManageOwnMemory: Boolean,
	agentManageOwnProviders: Boolean,
	agentManageProviderGrants: Boolean,
	agentUse: Boolean,
	agentUseReadTools: Boolean,
	agentUseSharedMemory: Boolean,
	agentUseWriteTools: Boolean,
	agentViewAudit: Boolean,
	colorblindMode: Boolean,
	createAppointment: Boolean,
	createDocument: Boolean,
	createIdo: Boolean,
	createMail: Boolean,
	createMessage: Boolean,
	createNote: Boolean,
	createTask: Boolean,
	dailyActivityUserSelect: Optional(Boolean),
	documentList: Boolean,
	mailList: Boolean,
	messageList: Boolean,
	noteList: Boolean,
	personalAccessTokenManageAll: Optional(Boolean),
	personalAccessTokenUse: Optional(Boolean),
	phoneCallList: Boolean,
	records: Boolean,
	taskList: Boolean,
});

export type UserConfigurationAndEffectiveRights = Static<typeof UserConfigurationAndEffectiveRightsRunType>;
